<!-- Color Section -->
@if (color_list.length && ![3].includes(current_activity_id)) {
  <div class="col">
    <h4 class="mb-3 display-4">{{ 'color' | translate }}</h4>
    <hr class="mb-3" />
    <div class="row row-cols-7 row-cols-md-12 g-3">
      @for (device of color_list; track device) {
        <div class="col col-auto">
          <div
            as-button
            class="device-color"
            [class.device-color__active]="device.id === global.selected_color_device_id"
            [class.elevate]="device.id !== global.selected_color_device_id"
            [style.background-color]="device.color | lowercase"
            [attr.aria-label]="device.original_color || device.color"
            (click)="selectColorClick(device)"
          ></div>
        </div>
      }
    </div>
    @if (global.active_device; as currentDevice) {
      <h5 class="mt-3 mb-0">
        {{ currentDevice.original_color || currentDevice.color }}
      </h5>
    }
  </div>
}

<!-- Storage Capacity -->
@if (storage_list.length && ![3].includes(current_activity_id)) {
  <div class="col mt-2rem">
    <h4 class="mb-3 display-4">
      {{ 'storage_capacity' | translate }}
    </h4>
    <hr class="mb-3" />
    <div class="row row-cols-2 row-cols-md-4 g-3">
      @for (device of storage_list; track device) {
        <div class="col">
          <div
            as-button
            class="card overflow-auto h-100"
            [ngClass]="{ 'p-3': device.admin }"
            [class.active-card]="getActiveStorage(device)"
        [class.elevate]="
          device.size !== global.selected_storage_size ||
          device.id !== global.selected_storage_device_id
        "
            [attr.aria-label]="device.size"
            (click)="selectStorageClick(device)"
            >
            <div class="card-body flex-column d-flex align-items-center justify-content-center">
              <h5 class="mb-1">{{ device.size }}</h5>
              <small class="text-secondary fw-normal">
                {{ device.price?.onetime?.cost_to_currency }}
              </small>
              @if (!!device.price?.monthly?.cost_to_currency) {
                <span
                  class="text-secondary text-size-sm fw-normal"
                  >
                  {{ 'plus' | translate }}
                  {{ appendMonthlyLabel(device.price.monthly.cost_to_currency) }}
                </span>
              }
            </div>
            <ng-container *ngTemplateOutlet="adminBadge; context: { admin: device.admin }" />
          </div>
        </div>
      }
    </div>
  </div>
}

<!-- Name Overrides -->
@if (name_override_list.length > 0 && show_options) {
  <div class="col mt-2rem">
    <h4 class="mb-3 display-4">
      {{ 'options' | translate }}
      <span class="text-secondary fs-6"> ({{ 'choose_one' | translate }}) </span>
    </h4>
    <hr class="mb-3" />
    <div class="row row-cols-1 g-3">
      @for (device of name_override_list; track device) {
        <div class="col">
          <div
            as-button
            class="card"
            [ngClass]="{ 'p-2': device.admin }"
            [class.active-card]="device.id === global.selected_name_override_id"
            [class.elevate]="device.id !== global.selected_name_override_id"
            [attr.aria-label]="device.name_override || device.name"
            (click)="selectNameOverrideClick(device)"
            >
            <div class="card-body">
              <h5 class="mb-1">{{ device.name_override || device.name }}</h5>
            </div>
            <ng-container *ngTemplateOutlet="adminBadge; context: { admin: device.admin }" />
          </div>
        </div>
      }
    </div>
  </div>
}

<ng-template #adminBadge let-admin="admin">
  @if (admin) {
    <ts-admin-override-badge
      class="position-absolute bottom-0 end-0 border-top-left-radius"
      />
  }
</ng-template>
